module.exports = __webpack_public_path__ + "media/images/female-fa9db19afb65c34fcaf0eab522ddf8f2.jpg";